import { client, getUrl } from "utils";

export const getBrandsRequest = (filterParams) => client.get(getUrl("brands", filterParams));

export const createBrandRequest = (body) => client.post("brands", body);

export const getBrandByCodeRequest = (code) => client.get(`brand/${code}`);

export const updateBrandRequest = (data) => client.put(`brand/${data.code}`, data);

export const deleteBrandRequest = (code) => client.delete(`brand/${code}`);
